/**
 * Navigation Source Tracker
 *
 * Tracks when users navigate to product pages and sets sessionStorage
 * so product pages know the navigation source for variant selector UX.
 *
 * This enables different UX behavior:
 * - From listing pages: Accordions OPEN, user confirms selections
 * - From cart/direct links: Accordions COLLAPSED, variant pre-selected (user already chose)
 */
(function() {
  'use strict';

  const pathname = window.location.pathname;

  // Listing pages - user is browsing, needs to confirm variant selection
  const listingPatterns = [
    /^\/collections\//,
    /^\/search/,
    /^\/pages\/.*search/,
    /^\/vendors\//,
    /^\/products$/
  ];

  const isListingPage = listingPatterns.some(pattern => pattern.test(pathname));

  // Use event delegation on document to catch all product link clicks
  document.addEventListener('click', function(e) {
    // Find if click was on or within a product link
    const link = e.target.closest('a[href*="/products/"]');
    if (!link) return;

    // Determine navigation source based on click context
    let navSource = null;

    // Check if click is from cart drawer or cart page (user already chose variant)
    const isFromCart = link.closest('.cart-drawer') ||
                       link.closest('.cart-item') ||
                       link.closest('[data-cart-drawer]') ||
                       link.closest('.cart-items') ||
                       link.closest('[data-cart-items]') ||
                       pathname.startsWith('/cart');

    if (isFromCart) {
      navSource = 'direct';  // Treat as confirmed selection
    } else if (isListingPage) {
      navSource = 'listing';  // User browsing, needs to confirm
    }

    // Set sessionStorage before navigation
    if (navSource) {
      try {
        sessionStorage.setItem('navigation_source', navSource);
      } catch (err) {
        // sessionStorage not available, fall back to referrer detection
      }
    }
  });
})();
